import React from "react"

class QuestionsAndAnswers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isItOpened: false,
      openAccordion: ``,
      isItOpened2: false,
      openAccordion2: ``,
      isItOpened3: false,
      openAccordion3: ``,
    }
  }

  handleAccordion = () => {
    if (this.state.isItOpened) {
      this.setState({ isItOpened: false, openAccordion: "" })
    } else {
      this.setState({ isItOpened: true, openAccordion: "show" })
    }
  }
  handleAccordion2 = () => {
    if (this.state.isItOpened2) {
      this.setState({
        isItOpened2: false,
        openAccordion2: ``,
      })
    } else {
      this.setState({
        isItOpened2: true,
        openAccordion2: `show`,
      })
    }
  }
  handleAccordion3 = () => {
    if (this.state.isItOpened3) {
      this.setState({
        isItOpened3: false,
        openAccordion3: ``,
      })
    } else {
      this.setState({
        isItOpened3: true,
        openAccordion3: `show`,
      })
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <h2 className="text-center">FAQ</h2>
          <section className="accordion mt-4">
            <div className="card">
              <div className="card-header">
                <h5 className="mb-0">
                  <button
                    onClick={this.handleAccordion}
                    className="btn btn-link text-dark"
                  >
                    We're so awkward in front of the camera, will you be able to
                    make us look okay?
                  </button>
                </h5>
              </div>
              <div className={`collapse ${this.state.openAccordion}`}>
                <div className="card-body">
                  <p>
                    UMMMM duh! This is the question I get asked the most. Most
                    of my clients, and by most I mean just about all, are not
                    being photographed regularly so it's natural to feel a
                    little weird. If I'm doing my job right though your anxiety
                    will melt away and you will feel totally comfortable. I'll
                    be cracking jokes the whole time you won't even notice that
                    I have a camera in your face.
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h5 className="mb-0">
                  <button
                    onClick={this.handleAccordion2}
                    className="btn btn-link text-dark"
                  >
                    Where are you based?
                  </button>
                </h5>
              </div>
              <div className={`collapse ${this.state.openAccordion2}`}>
                <div className="card-body">
                  <p>
                    I'm based out of Oakland, CA which is right outside of San
                    Francisco. But I'm happy to travel 😀
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h5 className="mb-0">
                  <button
                    onClick={this.handleAccordion3}
                    className="btn btn-link text-dark text-left"
                  >
                    Will we get digital edits from our wedding day and how long
                    will it take to get our photos back?
                  </button>
                </h5>
              </div>
              <div className={`collapse ${this.state.openAccordion3}`}>
                <div className="card-body">
                  <p>
                    I know we live in a digital age and digital photos are
                    important for backing up your day so a majority of my
                    packages come with the high resolution digital edits from
                    your wedding. You will get a link to your online gallery in
                    about 6 - 8 weeks. I'm all about editing each and every
                    photo and putting those finishing touches on each one.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    )
  }
}

export default QuestionsAndAnswers
